import React, { useState } from "react";
import { X, AlertTriangle } from "lucide-react";
import { INDEXING_ALLOWED } from "../lib/indexing";

/**
 * Discreet top banner shown only while the site is in pre-launch "noindex" mode.
 * Reminds admins/testers that this build is hidden from search engines.
 * Dismissible (sessionStorage) to avoid annoyance during a long session.
 */
export default function NoIndexBanner() {
  const [dismissed, setDismissed] = useState(() => {
    try {
      return sessionStorage.getItem("noindex_banner_dismissed") === "1";
    } catch {
      return false;
    }
  });

  if (INDEXING_ALLOWED || dismissed) return null;

  const handleDismiss = () => {
    try { sessionStorage.setItem("noindex_banner_dismissed", "1"); } catch {}
    setDismissed(true);
  };

  return (
    <div
      role="status"
      className="fixed top-0 inset-x-0 z-[100] bg-amber-500/95 text-[#1B132B] text-xs sm:text-sm font-medium shadow-md backdrop-blur"
      data-testid="noindex-banner"
    >
      <div className="max-w-7xl mx-auto px-4 py-1.5 flex items-center gap-3">
        <AlertTriangle className="w-4 h-4 flex-shrink-0" />
        <span className="flex-1 truncate">
          <strong>Mode test</strong> — Ce site n'est pas encore indexé par Google. Réservé aux testeurs avant le lancement officiel.
        </span>
        <button
          onClick={handleDismiss}
          className="flex-shrink-0 p-1 rounded hover:bg-black/10"
          aria-label="Fermer cette bannière"
          data-testid="dismiss-noindex-banner"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
